import './App.css';

import MapView from './components/MapView'
import React, {useState,useEffect}  from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from '@mui/material/Toolbar';
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Spinner from 'react-bootstrap/Spinner';

import './styles/app.css'
import './styles/sidebar.css'
import './styles/layername.css'
import './styles/geoserviceslist.css'
import './styles/imgpreview.css'
import './styles/layermetadata.css'
import './styles/button.css'
import './styles/custom_positions.css'
import "react-widgets/styles.css";
import './styles/popup.css'
import './sass/offcanvas.scss'
import './styles/filters.css'
import './styles/show_doc.css'
import '../node_modules/leaflet-geosearch/dist/geosearch.css';
import './styles/geosearch.css'
import './styles/table_meta.css'

const URL_BASE = process.env.REACT_APP_BASE_URL;

const URL_CONFIG = URL_BASE+'/configurations';
const URL_GEOSERVICES = URL_BASE+'/geoservices';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },

}));


const params = {
    headers: { 'Content-Type': 'application/json' },
    mode: 'cors',
};


function Header() {
  return (
    <div className="institutional-original-links">
      <img src={URL_BASE + 'images/logos.png'} alt="" aria-hidden="true" />
      {[
        ['Instituto Gulich', 'https://www.argentina.gob.ar/ciencia/conae/gullich', '0%', '38%'],
        ['Universidad Nacional de Córdoba', 'https://www.unc.edu.ar/', '38%', '34%'],
        ['CONAE', 'https://www.argentina.gob.ar/ciencia/conae', '72%', '28%'],
      ].map(([label, href, left, width]) => (
        <a key={label} href={href} target="_blank" rel="noopener noreferrer"
           title={label} aria-label={`${label} (abre en una nueva pestaña)`}
           style={{ left, width }} />
      ))}
    </div>
  );
}


function App() {
  const classes = useStyles();
  const [institutionsOpen, setInstitutionsOpen] = useState(false);

  const [configurations, setConfig] = useState('')
  
  const [geoservices, setGeoservices] = useState('')

  const [errorMessage, setErrorMessage] = useState('');
  
  const [status, setStatus] = useState(false);

  const [isLoading, setSppiner] = useState(true);

  // the useEffect is only there to call `fetchData` at the right time
  useEffect(() => {
  
    setSppiner(true)

    var ignore = false;
  
    const fetchData = async () => {
      try{

        const response_cf = await fetch(URL_CONFIG,params);
        //console.log("Searching in API the data of configurations....", response)
        if(!response_cf.ok){
            throw new Error(`HTTP error, status = ${response_cf.status}`);
        }
        var data =  await response_cf.json();
        if (!ignore){
          setConfig(data);
          //setStatus(true)
          //setSppiner(false)
        }
        const response_gs = await fetch(URL_GEOSERVICES,params);
        //console.log("Searching in API the data of configurations....", response)
        if(!response_gs.ok){
            throw new Error(`HTTP error, status = ${response_gs.status}`);
        }
        data =  await response_gs.json();
        if (!ignore){
          setGeoservices(data);
          setStatus(true)
          setSppiner(false)
        }

      }catch(error){
          console.log("Fallo en fetch...")
          console.error(error);
      }
        return () => { ignore = true }
      }
    fetchData()
  }, [])
  
  //console.log(configurations)
 
  return (
  
    (errorMessage ? <p className="error"> {errorMessage} </p> :
        
    <div className={`${classes.root} app-shell`}>
       
       {(isLoading ? 
      <><Spinner
          bsPrefix='custom-spinner'
          as="span"
          animation="border"
          size="xl"
          role="status"
          aria-hidden="true"
          />
          <span className="visually-hidden">Loading...</span>
        </>

          :
        <>
        <AppBar position="static" className="institutional-header">
          <Toolbar variant="dense" className="institutional-toolbar">
            <Typography variant="h5" color="inherit" align="center" className="institutional-title">
              {configurations ? configurations['map-data'].APP_TITLE : "SIN TITULO"}
            </Typography>
            <button type="button" className="institutions-toggle"
              aria-expanded={institutionsOpen} aria-controls="institutions-strip"
              onClick={() => setInstitutionsOpen(open => !open)}>
              Instituciones <span aria-hidden="true">{institutionsOpen ? '▴' : '▾'}</span>
            </button>
          </Toolbar>
          <div id="institutions-strip" className={`institutions-strip${institutionsOpen ? ' is-expanded' : ''}`}
            onKeyDown={event => {
              if (event.key === 'Escape') {
                setInstitutionsOpen(false);
                event.currentTarget.previousElementSibling.querySelector('button')?.focus();
              }
            }}>
            <div className="institutional-existing">{Header()}</div>
            <div className="institutional-new" aria-label="Instituciones participantes">
              {[
                ['CuencasLogo2.png', 'Autoridad de Cuencas', 'institutional-paper-logo institutional-wide-logo', 'https://prensa.cba.gov.ar/informacion-general/la-provincia-puso-en-funcionamiento-la-autoridad-de-cuencas-y-continua-con-el-plan-de-mitigacion-del-lago-san-roque/'],
                ['conicet-cordoba.png', 'CONICET Córdoba — CCT CBA', 'institutional-conicet-logo', 'https://cordoba.conicet.gov.ar/'],
                ['mincyt.png', 'Ministerio de Ciencia y Tecnología de Córdoba', 'institutional-paper-logo institutional-wide-logo', 'https://www.cba.gov.ar/institucional/'],
                ['ina.png', 'Instituto Nacional del Agua (INA)', 'institutional-ina-logo', 'https://www.argentina.gob.ar/ina'],
                ['oasis.png', 'OASIS', 'institutional-wide-logo', 'https://oasis-he.eu/'],
                ['unrc.svg', 'Universidad Nacional de Río Cuarto', 'institutional-unrc-logo', 'https://www.unrc.edu.ar/'],
              ].map(([file, label, logoClass, href]) => (
                <a key={file} href={href} target="_blank" rel="noopener noreferrer" aria-label={`${label} (abre en una nueva pestaña)`}>
                  <img className={logoClass} src={`${process.env.PUBLIC_URL}/logos-nuevos/${file}`} alt={label} />
                </a>
              ))}
            </div>
          </div>
        </AppBar>
      
      <Container maxWidth={false} disableGutters className="app-map-area">
        <div className="app-map-frame">
          {configurations && geoservices && status && <MapView config={configurations}
                                                               geoservices={geoservices}   
                                                                urlbase={URL_BASE}                                   
                                        ></MapView>}

        </div>
      </Container>
      </>
        )}
    </div>

      )
    );
}

export default App;
